import { render, staticRenderFns } from "./cascadeSelect.vue?vue&type=template&id=49132b4e&scoped=true&"
import script from "./cascadeSelect.vue?vue&type=script&lang=js&"
export * from "./cascadeSelect.vue?vue&type=script&lang=js&"
import style0 from "./cascadeSelect.vue?vue&type=style&index=0&id=49132b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49132b4e",
  null
  
)

export default component.exports